var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.category)?_c('div',{staticClass:"ps-container"},[_c('plugin-index',{attrs:{"action":"pluginStore/getPluginsByCategory","requestData":_vm.requestData,"plugins":_vm.plugins},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h1',[_vm._v(_vm._s(_vm.category.title))])]},proxy:true}],null,false,3653016063)})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }